import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    constructor(private http: HttpClient) { }

    getAllRole(body: any): Observable<any> {
        return this.http.post(environment.getAllRole, body);
    }

    createRole(body: any): Observable<any> {
        return this.http.post(environment.createRole, body);
    }

    updateRole(body: any): Observable<any> {
        return this.http.put(environment.updateRole, body);
    }

    deleteRole(body: any): Observable<any> {
        return this.http.post(environment.deleteRole, body);
    }
}
